// Opening times toggle
const handleOpeningTimesToggle = (): void => {
  const openingTimesHeaders = document.querySelectorAll<HTMLElement>('.opening-times-header');
  
  openingTimesHeaders.forEach((header) => {
    header.addEventListener('click', (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      
      const parent = header.closest('.opening-times');
      if (parent) {
        parent.classList.toggle('active');
        
        const detailsElement = parent.querySelector<HTMLElement>('.opening-times-details');
        if (detailsElement) {
          detailsElement.classList.toggle('is-open');
        }
      }
    });
  });
};

// My Account button toggle
const handleAccountToggle = (): void => {
  const accountButtons = document.querySelectorAll<HTMLElement>('.primary-nav__btn');
  const accountItems = document.querySelectorAll<HTMLElement>('.my-account-button-items');
  
  accountButtons.forEach((button) => {
    button.addEventListener('click', (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      
      accountItems.forEach(item => {
        item.classList.toggle('is-open');
      });
      accountButtons.forEach(btn => {
        btn.classList.toggle('is-open');
      });

      const getInTouchContent = document.getElementById('getInTouchContent');
      const getInTouchTrigger = document.getElementById('getInTouchTrigger');
      if (getInTouchContent && getInTouchContent.classList.contains('is-open')) {
        getInTouchContent.classList.remove('is-open');
        if (getInTouchTrigger) {
          getInTouchTrigger.setAttribute('aria-expanded', 'false');
        }
        
        const openingTimesParent = document.querySelector('.opening-times');
        const openingTimesDetails = document.querySelector('.opening-times-details');
        if (openingTimesParent) openingTimesParent.classList.remove('active');
        if (openingTimesDetails) openingTimesDetails.classList.remove('is-open');
      }
    });
  });

  document.addEventListener('click', (e: Event) => {
    const target = e.target as HTMLElement;
    const isClickInsideButton = Array.from(accountButtons).some(btn => btn.contains(target));
    const isClickInsideItems = Array.from(accountItems).some(item => item.contains(target));

    if (!isClickInsideButton && !isClickInsideItems) {
      accountItems.forEach((item) => {
        item.classList.remove('is-open');
      });
      accountButtons.forEach((btn) => {
        btn.classList.remove('is-open');
      });
    }
  });
};

const init = (): void => {
  handleOpeningTimesToggle();
  handleAccountToggle();
};

export {
  init
};
